import React, { useContext } from 'react';
import i18next from 'i18next';
import { Textlink } from '../../../../AutostadtTabComponents/Button';
import SubpageBlue from '../../SubpageBlue';
import './styles.scss';
import { Trans } from 'react-i18next';
import { setOverlay } from '../../../../../utils/SspProvider/dispatchFunctions';
import { OverlayEnum } from '../../../../../enums';
import SspProviderContext from '../../../../../utils/SspProvider/context';

export default function OpeningHours() {
    const store = useContext(SspProviderContext);
    return (
        <SubpageBlue
            title='Öffnungszeiten'
            className='opening-hours'
            headerChildren={
                <>
                    <p>
                        <Trans
                            i18nKey={'OpeningHoursHeader1'}
                            components={{
                                strong: <strong />,
                                br: <br />,
                            }}
                        />
                    </p>
                    <p>
                        <Trans
                            i18nKey={'OpeningHoursHeader2'}
                            components={{
                                strong: <strong />,
                                br: <br />,
                            }}
                        />
                    </p>
                    <p>
                        <Trans
                            i18nKey={'OpeningHoursHeader3'}
                            components={{
                                strong: <strong />,
                                br: <br />,
                            }}
                        />
                    </p>
                </>
            }
        >
            <>
                <p>
                    <Trans
                        i18nKey={'OpeningHoursBody1'}
                        components={{
                            strong: <strong />,
                            br: <br />,
                        }}
                    />
                </p>
                <p>
                    <Trans
                        i18nKey={'OpeningHoursBody2'}
                        components={{
                            strong: <strong />,
                            br: <br />,
                        }}
                    />
                </p>

                <p>
                    <Trans
                        i18nKey={'OpeningHoursBody4'}
                        components={{
                            strong: <strong />,
                            br: <br />,
                        }}
                    />
                </p>
                <p>
                    <Trans
                        i18nKey={'OpeningHoursBody6'}
                        components={{
                            strong: <strong />,
                            br: <br />,
                        }}
                    />
                </p>
                <p>
                    <Trans
                        i18nKey={'OpeningHoursBodyChangesPossible'}
                        components={{
                            strong: <strong />,
                            br: <br />,
                        }}
                    />
                </p>
            </>
        </SubpageBlue>
    );
}
